import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'

const ItemPromo = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)
        
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" },actionParam: {sview:'itemPromo'} }}
            formStyle={{ width: "755px" }}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Descriptions' />}
            formObject={formObject} >
            <div>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Name" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="" style={{width:'560px'}}
                    action={{ InputType: "input", paramName: "itemName" }}
                />
            </div>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "promoShort" }} value="Short Description" />
                </span>
                <FormRichText formObject={formObject} rowKey="" rows="3" cols="82" className=""
                    action={{ paramName: "promoShort" }} />
            </div>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "promoLong" }} value="Long Description" />
                </span>
                <FormRichText formObject={formObject} rowKey="" rows="15" cols="82" className=""
                    action={{ paramName: "promoLong" }} />
            </div>
        </FormDialog>
    )
}

export default withView(ItemPromo, "itemPromo", "itemHeader")